import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";

// Lazy load below-the-fold components for better FCP
const QuizSection = lazy(() => import("@/components/QuizSection"));
const BeforeAfterGallery = lazy(() => import("@/components/BeforeAfterGallery"));
const PortfolioSection = lazy(() => import("@/components/PortfolioSection"));
const PricingSection = lazy(() => import("@/components/PricingSection"));
const ExpertSection = lazy(() => import("@/components/ExpertSection"));
const ReviewsSection = lazy(() => import("@/components/ReviewsSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const LocationSection = lazy(() => import("@/components/LocationSection"));
const StickyFooter = lazy(() => import("@/components/StickyFooter"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <HeroSection />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <QuizSection />
        <PortfolioSection />
        <PricingSection />
        <ExpertSection />
        <ReviewsSection />
        <FAQSection />
        <LocationSection />
        <StickyFooter />
      </Suspense>
    </div>
  );
};

export default Index;
